
import FooterAbsolute from '../components/FooterAbsolute'
import { Link } from 'react-router-dom'; 
function PageNotFound() {
  return (
    <div>
      <div id="PageNotFound">
      <h1>Page non trouvé</h1>
      <p>La page que vous recherchez n'a pas été trouvée </p>
      <Link to="/" > <button>Retour à l'accueil</button></Link>
      </div>
      <FooterAbsolute />
    </div>
  );
}

export default PageNotFound;